import { Dispatch, SetStateAction } from "react";
import { CaseType } from "src/types/case";

export type CaseListingType = CaseType & {
  id: number;
  investigated_at: string | null;
  color_idx: 1 | 2 | 3 | 4 | 5;
  computed_status: string;
  created_at: string | null;
  active_pa: boolean;
  active_pa_id: number;
  precert_maximum: boolean;
  precert_minimum: boolean;
  cancelled_state: boolean;
  transfer_rx_button: boolean;
  pdp_button: boolean;
  prescription_id: number;
  drug_name: string;
  category: string;
  case_type: string;
  treated_button: boolean;
  patient: {
    id: number;
    external_id: string;
    firstlastname: string;
    dob: string;
  };
  doctor: {
    id: number;
    firstlastname: string;
  };
  treatment?: {
    id: number;
    scheduled_at: string | null;
  };
  xfer_rx_sp: boolean;
  buy_and_bill: boolean;
  appeal_precert_id: number;
  date_of_treatment: boolean;
  pdp_xfer: boolean;
  original_id: string;
  pharmacy: string;
  rx_shipped: string;
  status_color: string;
  review_case_notes: boolean;
  no_action_required: boolean;
  cancel_submission: boolean;
  release_order: boolean;
  transfer_to_pharmacy: boolean;
  transfer_to_rx:boolean;
  prescription_renewal:boolean;
  primary_insurance:string;
};

export type CaseListErrorResponse = {
  code: number;
  error: string;
};

export type caseListAPIResponse = {
  code: number;
  message: string;
  data: {
    case: CaseType[];
  };
};

export type CaseListAPIResponseType = {
  status: number;
  cases: CaseListingType[];
  total_pages: number;
  investigated: number;
  pending: number;
  quarter_date: string;
  medical_reimbursement_rate: string;
};

export type QueryParamsState = {
  open: string | boolean;
  sort_by: string;
  direction: "asc" | "desc";
  search_query: string;
  date_from: string;
  date_to: string;
  page: number;
  category_type: string;
  pagination: boolean;
};

export enum QueryStateActions {
  CHANGE_CASE_STATUS = "changeCaseStatus",
  CHANGE_SORT_PARAMS = "changeSortParams",
  CHANGE_SEARCH_QUERY = "changeSearchQuery",
  CHANGE_FROM_DATE = "changeFromDate",
  CHANGE_TO_DATE = "changeToDate",
  CLEAR_STATE = "clearState",
  CHANGE_PAGE = "changePage",
  CHANGE_CATEGORY_TYPE = "changeCategoryType",
  CHANGE_PAGINATION_BIT = "changePaginationBit",
}

export type QueryStateActionType =
  | {
      type: QueryStateActions.CHANGE_CASE_STATUS;
      payload: boolean | string;
    }
  | {
      type: QueryStateActions.CHANGE_CATEGORY_TYPE;
      payload: string;
    }
  | {
      type: QueryStateActions.CHANGE_SORT_PARAMS;
      payload: {
        sort_by: string;
        direction: "asc" | "desc";
      };
    }
  | {
      type: QueryStateActions.CHANGE_SEARCH_QUERY;
      payload: string;
    }
  | {
      type: QueryStateActions.CHANGE_FROM_DATE;
      payload: string;
    }
  | {
      type: QueryStateActions.CHANGE_TO_DATE;
      payload: string;
    }
  | {
      type: QueryStateActions.CHANGE_PAGE;
      payload: number;
    }
  | {
      type: QueryStateActions.CLEAR_STATE;
    }
  | {
      type: QueryStateActions.CHANGE_PAGINATION_BIT;
      payload: boolean;
    };

// export type DownloadZipResponseType = {
//   response: string;
//   report_name: string;
// };
export type DownloadPDFResponseTypeApi = {
  code: number;
  message: string;
  response: string;
  report_name: string;
};

export type DownloadZipErrorType = {
  code: number;
  error: string;
};
export type statetype = {
  case_id: number;
  id: number;
  insurance_id?: number;
};

export type RenderNextStepProps = {
  kase: CaseListingType;
  showHideModalForTreatment: Dispatch<
    SetStateAction<{
      isModalVisible: boolean;
      caseId: number;
      prescriptionId: number;
    }>
  >;
  setDataForCancelModal: Dispatch<
    SetStateAction<{
      isModalVisible: boolean;
      caseId: number;
      prescriptionId: number;
    }>
  >;
  onTreatedOrNotTreatedButtonClicked: (
    value: string,
    treatment_id: number
  ) => void;
  setDataForTreatedOrNotTreatedTreatmentModal: Dispatch<
    SetStateAction<{
      isModalVisible: boolean;
      caseId: number;
      treatment_id: number;
    }>
  >;
  getCaseListing: <TBodyType, TPathParams, TQueryParams>(
    body?: TBodyType | undefined,
    pathFromData?: TPathParams | undefined,
    queryFromData?: TQueryParams | undefined
  ) => void;
};

export type DownloadZipResponseType = {
 
  code:number;
  message:string;
  response:string;
  report_name: string;
};

export type ExcelSheetHeader = "Case ID Number" |
    "Rx Submitted" |
    "RX Shipped" |
    "Patient Name" |
    "Patient DOB" |
    "Physician Name" |
    "Pharmacy Name" |
    "Case Status"

export type ExcelSheetCaseProps = {
  "Case ID Number": string;
  "Rx Submitted": string;
  "RX Shipped": string;
  "Patient Name": string;
  "Patient DOB": string;
  "Physician Name": string;
  "Pharmacy Name": string;
  "Case Status": string;
}